import clsx from "clsx";
import "./DocumentUploadModalContent.scss";

type DocumentUploadModalContentProps = {
  overrideClassNames?: string;
  children?: React.ReactNode;
};

export const DocumentUploadModalContent = ({
  overrideClassNames,
  children,
}: DocumentUploadModalContentProps) => {
  return (
    <div className={clsx("ui-upload-modal-body", overrideClassNames)}>
      {children}
    </div>
  );
};
